module.exports = __webpack_public_path__ + "img/121ne.ddecd930.svg";